<template>
    <div>
        <el-form label-width="110px" label-position="left" :inline="true" :model="data" class="query-form" size="small">
            <h1 class="inquiryDetailsTitle" style="position: relative;display: flex;align-items: center;">商品询价信息
              <el-button  size="small"  style="width: 80px;position: absolute;right: 20px;" @click.native="goback">返回</el-button>
            </h1>
            <el-form-item class="query-form-item" label="ID:">
                {{ data.id }}
            </el-form-item>
            <el-form-item class="query-form-item" label="处理状态:">
                {{ data.state==1?'未处理':'已处理' }}
                <el-button v-if="data.state==1" style="margin-left: 20px;" type="text"  @click="editFreight()">处理</el-button>
            </el-form-item>
            <el-form-item class="query-form-item" label="联系人:">
                {{ data.lastName }}{{ data.firstName }}
            </el-form-item>
            <el-form-item class="query-form-item" label="联系电话:">
              {{ data.tel }}
            </el-form-item>
            <el-form-item class="query-form-item" label="公司名称:">
              {{ data.companyName }}
            </el-form-item>
            <el-form-item class="query-form-item" label="公司地址:">
              {{ data.address }}
            </el-form-item>
            <el-form-item class="query-form-item" label="邮编:">
              {{ data.zipcode }}
            </el-form-item>
            <el-form-item class="query-form-item" label="城市:">
              {{ data.city }}
            </el-form-item>
            <el-form-item class="query-form-item" label="国家:">
              {{ data.country }}
            </el-form-item>
            <el-form-item class="query-form-item" label="Email:">
              {{ data.email }}
            </el-form-item>
            <el-form-item class="query-form-item query-form-item-big" label="备注信息:">
              {{ data.remark }}
            </el-form-item>
            <el-form-item class="query-form-item" label="下单时间:">
                {{  data.createTime
                  | formatDateStr("yyyy-MM-dd hh:mm:ss")}}
            </el-form-item>
            <el-form-item class="query-form-item" label="处理时间:">
                <span v-if="data.handleTime!=null">{{data.handleTime | formatDateStr("yyyy-MM-dd hh:mm:ss")}}</span>
                <span v-if="data.handleTime==null">--</span>
            </el-form-item>
        </el-form>

        <el-table ref="multipleTable" v-loading="loading" width="1200px" :data="list"
            :header-cell-style="{ background: '#F4F4F5', color: '#606266' }" border>
            <el-table-column label="产品编码" prop="commodityNum" width="180" align="center"/>
            <el-table-column label="图片" prop="commodityUrl" :show-overflow-tooltip="true" align="center">
              <template slot-scope="scope">
                <el-popover placement="right" trigger="hover">
                    <img :src="scope.row.commodityUrl" style="width:400px;border-radius:3px;">
                    <img slot="reference" :src="scope.row.commodityUrl"
                        style="max-height: 50px;max-width: 50px;border-radius:5px;">
                </el-popover>
            </template>
            </el-table-column>
            <el-table-column label="商品名称" prop="commodityName" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="重量" prop="speclWeight" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="材质规格" prop="specStand" :show-overflow-tooltip="true" align="center" />
        </el-table>
         <!-- 修改运费 -->
         <el-dialog title="回复询价" :visible.sync="freightVisible" :before-close="cancelFreight" width="35%" v-dialogDrag>
          <el-form >
            <el-form-item width="80%" >
              <el-input type="test" v-model="list[0].commodityName" disabled>
                <template slot="prepend">商品：</template>
              </el-input>
          </el-form-item>
              <el-form-item width="80%" >
                  <el-input type="test" v-model="price">
                    <template slot="prepend">价格：</template>
                  </el-input>
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button @click.native="cancelFreight">取消</el-button>
              <el-button type="primary" @click.native="updateExpressFeeFn(price)">提交</el-button>
          </div>
      </el-dialog>
    </div>
</template>

<script>
    import {
        getAskerDetailsApi,
        replyMailApi
    } from "@/api/inquiry/inquiry";
    export default {
        data() {
            return {
                loading: false,
                data:{},
                list: [{
                  commodityNum:"",
                  commodityUrl:"",
                  commodityName:"",
                  speclWeight:"",
                  specStand:""
                }],
                query:{
                  id:0
                },
                freightVisible: false,
                price:""
            };
        },
        methods: {
          goback() {
                this.$router.go(-1)
            },
            getAskerDetailsFn() {
                getAskerDetailsApi(this.query)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.data = response.data || {};

                        this.list[0].commodityNum=this.data.commodityNum;
                        this.list[0].commodityUrl=this.data.commodityUrl;
                        this.list[0].commodityName=this.data.commodityName;
                        this.list[0].speclWeight=this.data.speclWeight;
                        this.list[0].specStand=this.data.specStand;
                    })
                    .catch(() => {});
            },
             //修改运费
             updateExpressFeeFn(price) {
                let theId = {
                    id: this.query.id,
                    price: price
                }
                replyMailApi(theId)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.freightVisible = false;
                        this.$message.success("操作成功");
                        this.getAskerDetailsFn();
                    })
                    .catch(() => {});
            },
            editFreight() {
                this.freightVisible = true;
            },
            cancelFreight() {
                this.freightVisible = !this.freightVisible;
                // this.getDetailsFn();
            },
        },
        filters: {},
        mounted() {},
        created() {
          this.query.id = this.$route.query.id;
          this.getAskerDetailsFn();
        }
    };

</script>
<style scoped>
    /deep/ .query-form {
        color: #606266;
        width: 1200px !important;
        border: 1px solid #f4f4f5;
        border-bottom: none;
        margin-bottom: 40px;
        /* border-left: none; */
    }

    /deep/ .query-form-item {
        /* display: block !important; */
        width: 50% !important;
        margin-right: 0 !important;
        padding: 10px 0;
        margin-bottom: 0 !important;
        border-bottom: 1px solid #f4f4f5;
        /* border-left: 1px solid #F4F4F5; */
    }

    /deep/ .query-form-item-big {
        width: 100% !important;
    }

    /deep/ .el-form-item__label {
        padding-left: 20px;
    }

    /deep/ .query-form-item-big .el-form-item__content {
        padding: 0 20px;
        text-indent: 4em;
    }

    .inquiryDetailsTitle {
        line-height: 50px;
        background: #f4f4f5;
        padding-left: 20px;
    }

    /deep/ .el-table--border {
        width: 1200px;
    }

    /deep/ .el-table__body td {
        padding: 12px 0 !important;
    }

    /deep/ .el-input.is-disabled .el-input__inner {
      background-color: #fff;
    }
</style>
